export default {
  from: {
    index: '首頁',
    service: '我們的服務',
    about: '關於我們',
    putai: 'PROTAC 设计平台',
    contact: '聯繫我們',
    title: '歡迎使用香港普泰医药科技我們是您設計PROTAC的首選',
    more: '瞭解更多資訊',
    changeLanguage: '中文（繁）',
    partners: '我們的優勢',
    sales: '關於售後服務',
    salesText: '科技一對一溝通，全程負責。 協助客戶論文答辯或修改或答覆審稿意見。 售後服務的開始才是我們整個項目的開始。',
    process: '關於過程',
    processText: '高效工作，全天服務，可按客戶要求短時完成項目計算，定期迴響計算進度，數據結果準確且預測性强。',
    report: '關於報告',
    reportText: 'SCI級圖文報告，中英文可選。',
    product: '我們的產品',
    product01: 'PT 36-3090服務器（4U）',
    product02: 'PT 36-3090服務器（2U）',
    product03: '多卡位節點服務器',
    product04: 'PT Gen 2服務器',
    product05: 'CPU',
    product06: '記憶體',
    product07: '網卡/ RAID卡/HBA卡',
    product08: '硬碟',
    product09: 'PT Storage SL2000系列',
    product10: 'PT Storage SL5000系列',
    product11: 'PT Storage SL9900系列',
    product12: 'PT交換機',
    product13: '萬兆交換機',
    product14: '無線網絡設備',
    product15: '路由器',
    product16: '系統集成',
    product17: '全塔式多卡位分子動力學模擬單機工作站',
    product18: '多核心計算化學單機工作站',
    product19: 'RTX3080TI分子動力學模擬GPU',
    product20: 'RTX4090分子動力學模擬GPU',
    product21: 'Tesla機器學習GPU',
    tab01: '機架伺服器',
    tab02: '服務器配件',
    tab03: '存儲',
    tab04: '全國產服務器',
    tab05: '工作站',
    tab06: 'GPU服務器',
    all: '查看全部',
    case: '我們的案例',
    company: '香港普泰医药科技',
    company1: '高性能工作站定制',
    company2: '分子模擬計算環境搭建',
    company3: '預裝常用分子類比軟體',
    company4: '二年質保，3小時內響應服務',
    newProduct: '最新產品',
    illustrate: '產品說明',
    supplier: '醫藥分子模擬解決方案提供商',
    design: 'PROTAC分子在線設計平台',
    spec: '產品規格',
    service01: '定制化理論計算解決方案',
    service02: '免費獲取類比計算方案報價',
    service03: '500+認證工程師·1對1溝通出方案·保證數據真實&可重複',
    aboutUs01: '“是一家由多名博士組成的創新型技術服務公司，團隊成員在藥物開發，分子模擬，人工智慧領域有多年從業經驗。',
    aboutUs02: '我們以專業的態度做適用的解決方案，致力於成為分子模擬科技行業優秀的服務商。 普泰医药科技擁有一套完整的從分子模擬研究到化學合成，活性測試的技術服務體系。”'
  },
  partner: {
    title: '我們的合作夥伴',
    school01: '中科院青島生物能源研究所',
    school02: '中科院瀋陽應用化學研究所',
    school03: '中科院生態環境科學研究中心',
    school04: '中國林業科學院林產化學工業研究所',
    school05: '成都源術科技有限公司',
    school06: '四川大學',
    school07: '香港大學',
    school08: '浙江大學',
    school09: '蘭州大學',
    school10: '成都市術源科技有限公司',
    school11: '同濟大學',
    school12: '海南大學',
    school13: '山東大學',
    school14: '江蘇大學',
    school15: '等近百所組織和高校',
    school16: '西南大學',
    school17: '暨南大學',
    school18: '中南大學湘雅第三醫院',
    school19: '深圳市術理科技有限公司',
  },
  dr: {
    Founder: '创始人',
    Partner: '合作组织',
    Interests: '研究兴趣',
    name01: '代亮教授',
    name02: '孙良',
    name03: '熊文博士',
    name04: '李辛雨',
    name05: '陈嘉璐',
    conetent01: '软物质材料计算',
    conetent02: '生物物理',
    conetent03: '高分子物理',
    introduce01: '助理教授(香港城市大学)顾问',
    introduce02: '博士生(香港城市大学)项目负责人',
    introduce03: '博士后 (贝勒医学院)生物活性测试平台负责人',
    introduce04: '博士生(香港中文大学深圳)PROTAC设计平台及分子模拟平台负责人',
    introduce05: '博士生(香港城市大学)AI平台负责人',
  },
  product: {
    indexP101: '作為一款自主研發的主流2U兩路機架式伺服器，H3C UniServer R4900 G5基於新一代的英特爾 ® 至强 ® 可擴展處理器，可實現多達52%的處理器浮點性能提升和42%的覈心數量新增，配合8通道3200MT/s DDR4記憶體科技，為用戶提供高達60%的頻寬提升。',
    indexP201: '通過多達14個標準PCIe 4.0插槽和多達41個硬碟插槽1的本地存儲支持，實現卓越的擴展能力。 96%的電源能效，以及5℃- 45℃的標準工作溫度設計，為用戶提供更高的能效回報。',
    subTitle01: '面向通用計算的雙路機架伺服器',
    indexP102: '作為一款自主研發的主流2U兩路機架式伺服器，H3C UniServer R4900 G3基於新一代的英特爾 ® 至强 ® 可擴展家族處理器，可實現多達71%的性能提升和27%的覈心數量新增，配合6通道2933MT/s DDR4記憶體科技，為用戶提供高達50%的性能提升。',
    indexP202: '通過多達10個PCIe 3.0插槽1和多達40個硬碟插槽1的本地存儲支持，實現卓越的擴展能力。 可選配寘安全智慧防護模塊，為關鍵業務提供全方位的貼身防護。 96%的電源能效，以及5℃- 50℃的標準工作溫度設計，為用戶提供更高的能效回報。',
    subTitle02: '面向通用計算的雙路機架伺服器',
    indexP103: 'HPE ProLiant DL380 Gen10服務器旨在有效的降低成本和複雜性。 第二代英特爾 ® 至强 ® 可擴展處理器，性能提升多達60%，覈心數量新增27%，同時支持多達3TB的HPE DDR4 2933 MT/s智慧記憶體，性能提升多達82%。',
    indexP203: '服務器支持12Gb/s SAS介面，多達20個NVMe硬碟，以及廣泛的計算選件。 HPE NVDIMM及DC永久記憶體為資料庫的分析負荷提供了更好的效能優勢，適合從基礎應用到關鍵業務的任何工作負載，且簡易部署。',
    subTitle03: '面向多負載計算的高性能通用機架伺服器',
    indexP104: 'HPE ProLiant DL580 Gen10服務器採用4U主機殼，是一個安全的、高度可擴展的四路服務器，具有高性能、可擴展性和可用性。 HPE ProLiant DL580 Gen10服務器支持第二代英特爾 ® 至强 ® 可擴展處理器，提供的處理能力遠遠高於之前幾代產品，多達十六個PCIe3.0插槽，外加HPE OneView和HPE iLO 5帶來的簡潔的自動化管理。',
    indexP204: 'HPE ProLiant DL580 Gen10服務器非常適於業務關鍵型工作負載，以及效能至上的通用4P數據密集型應用程序。',
    subTitle04: '面向關鍵業務的高擴展企業級四路機架伺服器',
    subTitle09: 'H3C UniStor CF2000存儲產品作為新一代的SAN產品，支持12-128GB的設備緩存，可提供高達20萬的IOPS和入門級產品的市場價格，提供給客戶可負擔的應用加速方案。',
    subTitle10: 'H3C CF存儲系統全閃存配寘起價僅為19000美元',
    subTitle11: 'X10000支持x86架構與ARM架構CPU',
    column01: '產品編碼',
    column02: '產品程式碼',
    column03: '描述',
  },
  footer: {
    title: "聯繫我們",
    phone: '電話',
    email: '郵箱',
    address: '地址',
    location: '香港特別行政區九龍觀塘創業街15號萬泰利廣場21樓C單元',
    wx: '掃碼添加客服微信',
    gzh: '掃碼關注魔德科技微信公眾號，獲取最新分子模擬資訊',
    pre1: '上一篇：',
    pre2: '上一個產品',
    next1: '下一篇：',
    next2: '下一個產品',
    no: '沒有了'
  },
  language: {
    Chinese: '中文(繁)',
    English: 'English',
  }

}
